var React = require('react');

function Signal1way (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"currentColor","fillRule":"evenodd"},[React.createElement("path",{"d":"M3.142 18.1h3v-3h-3v3zm5 0h3v-7h-3v7zm5 0h3v-12h-3v12zm5 0h3V.1h-3v18z","opacity":".5","key":0}),React.createElement("path",{"d":"M3.85 6.491v-6h-1l-2 1v1h1.5v4h1.5zm4.925-1.716l.528-2.886h1.1L9.426 6.49h-1.15l-.617-2.623-.604 2.623H5.908l-.98-4.602H6.03l.528 2.886.632-2.886h.942l.642 2.886z","key":1})]));
}

Signal1way.defaultProps = {"width":"22","height":"19","viewBox":"0 0 22 19"};

module.exports = Signal1way;

Signal1way.default = Signal1way;
